'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

var utils = require('./utils');

module.exports = function (_Plugin) {
  _inherits(SnapZoom, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {number} [options.width] the desired width to snap (to maintain aspect ratio, choose only width or height)
   * @param {number} [options.height] the desired height to snap (to maintain aspect ratio, choose only width or height)
   * @param {number} [options.time=1000]
   * @param {string|function} [options.ease=easeInOutSine] ease function or name (see http://easings.net/ for supported names)
   * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] starts the snap immediately regardless of whether the viewport is at the desired zoom
   * @param {boolean} [options.noMove] zoom but do not move
   *
   * @event snap-zoom-start(Viewport) emitted each time a fit animation starts
   * @event snap-zoom-end(Viewport) emitted each time fit reaches its target
   * @event snap-zoom-end(Viewport) emitted each time fit reaches its target
   */


  function SnapZoom(parent, options) {
    _classCallCheck(this, SnapZoom);

    var _this = _possibleConstructorReturn(this, (SnapZoom.__proto__ || Object.getPrototypeOf(SnapZoom)).call(this, parent));

    options = options || {};
    _this.width = options.width;
    _this.height = options.height;

    if (_this.width > 0) {
      _this.x_scale = parent._screenWidth / _this.width;
    }

    if (_this.height > 0) {
      _this.y_scale = parent._screenHeight / _this.height;
    }

    _this.xIndependent = utils.exists(_this.x_scale);
    _this.yIndependent = utils.exists(_this.y_scale);
    _this.x_scale = _this.xIndependent ? _this.x_scale : _this.y_scale;
    _this.y_scale = _this.yIndependent ? _this.y_scale : _this.x_scale;
    _this.time = utils.defaults(options.time, 1000);
    _this.ease = utils.ease(options.ease, 'easeInOutSine');
    _this.center = options.center;
    _this.noMove = options.noMove;
    _this.stopOnResize = options.stopOnResize;
    _this.removeOnInterrupt = options.removeOnInterrupt;
    _this.removeOnComplete = utils.defaults(options.removeOnComplete, true);
    _this.interrupt = utils.defaults(options.interrupt, true);

    if (_this.time === 0) {
      parent.container.scale.x = _this.x_scale;
      parent.container.scale.y = _this.y_scale;

      if (_this.removeOnComplete) {
        _this.parent.removePlugin('snap-zoom');
      }
    } else if (options.forceStart) {
      _this.createSnapping();
    }

    return _this;
  }

  _createClass(SnapZoom, [{
    key: 'createSnapping',
    value: function createSnapping() {
      var scale = this.parent.scale;
      this.snapping = {
        time: 0,
        startX: scale.x,
        startY: scale.y,
        deltaX: this.x_scale - scale.x,
        deltaY: this.y_scale - scale.y
      };
      this.parent.emit('snap-zoom-start', this.parent);
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.snapping = null;

      if (this.width > 0) {
        this.x_scale = this.parent._screenWidth / this.width;
      }

      if (this.height > 0) {
        this.y_scale = this.parent._screenHeight / this.height;
      }

      this.x_scale = this.xIndependent ? this.x_scale : this.y_scale;
      this.y_scale = this.yIndependent ? this.y_scale : this.x_scale;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.snapping = null;
    }
  }, {
    key: 'wheel',
    value: function wheel() {
      if (this.removeOnInterrupt) {
        this.parent.removePlugin('snap-zoom');
      }
    }
  }, {
    key: 'down',
    value: function down() {
      if (this.removeOnInterrupt) {
        this.parent.removePlugin('snap-zoom');
      } else if (this.interrupt) {
        this.snapping = null;
      }
    }
  }, {
    key: 'update',
    value: function update(elapsed) {
      if (this.paused) {
        return;
      }

      if (this.interrupt && this.parent.countDownPointers() !== 0) {
        return;
      }

      var oldCenter = void 0;

      if (!this.center && !this.noMove) {
        oldCenter = this.parent.center;
      }

      if (!this.snapping) {
        if (this.parent.scale.x !== this.x_scale || this.parent.scale.y !== this.y_scale) {
          this.createSnapping();
        }
      } else if (this.snapping) {
        var snapping = this.snapping;
        snapping.time += elapsed;

        if (snapping.time >= this.time) {
          this.parent.scale.set(this.x_scale, this.y_scale);

          if (this.removeOnComplete) {
            this.parent.removePlugin('snap-zoom');
          }

          this.parent.emit('snap-zoom-end', this.parent);
          this.snapping = null;
        } else {
          var _snapping = this.snapping;
          this.parent.scale.x = this.ease(_snapping.time, _snapping.startX, _snapping.deltaX, this.time);
          this.parent.scale.y = this.ease(_snapping.time, _snapping.startY, _snapping.deltaY, this.time);
        }

        var clamp = this.parent.plugins['clamp-zoom'];

        if (clamp) {
          clamp.clamp();
        }

        if (!this.noMove) {
          if (!this.center) {
            this.parent.moveCenter(oldCenter);
          } else {
            this.parent.moveCenter(this.center);
          }
        }
      }
    }
  }, {
    key: 'resume',
    value: function resume() {
      this.snapping = null;

      _get(SnapZoom.prototype.__proto__ || Object.getPrototypeOf(SnapZoom.prototype), 'resume', this).call(this);
    }
  }]);

  return SnapZoom;
}(Plugin);